import { useState, useEffect } from "react";
import { RxChevronLeft, RxChevronRight } from "react-icons/rx";
import ReactPaginate from "react-paginate";
import { Button, buttonVariants } from "./Button";
import { cn } from "@/lib/utils";

const DataTablePagination = ({ table, pageIndex }) => {
  const [pageRangeDisplayed, setPageRangeDisplayed] = useState(2);

  const handlePageClick = selectedItem => {
    table.setPageIndex(selectedItem.selected);
  };

  const updatePageRangeDisplayed = () => {
    const width = window.innerWidth;
    if (width < 375) {
      setPageRangeDisplayed(0);
    } else if (width < 490) {
      setPageRangeDisplayed(1);
    } else if (width < 576) {
      setPageRangeDisplayed(2);
    } else {
      setPageRangeDisplayed(3);
    }
  };

  useEffect(() => {
    updatePageRangeDisplayed();
    window.addEventListener("resize", updatePageRangeDisplayed);
    return () => {
      window.removeEventListener("resize", updatePageRangeDisplayed);
    };
  }, []);

  return (
    <ReactPaginate
      previousLabel={
        <Button
          disabled={!table.getCanPreviousPage()}
          variant="ghost"
          size="icon"
        >
          <span className="sr-only">Go to previous page</span>
          <RxChevronLeft className="h-5 w-5 rtl:rotate-180" />
        </Button>
      }
      nextLabel={
        <Button disabled={!table.getCanNextPage()} variant="ghost" size="icon">
          <span className="sr-only">Go to next page</span>
          <RxChevronRight className="h-5 w-5 rtl:rotate-180" />
        </Button>
      }
      breakLabel={
        <Button variant="ghost" size="icon">
          ...
        </Button>
      }
      forcePage={pageIndex}
      pageCount={table.getPageCount()}
      marginPagesDisplayed={pageRangeDisplayed == 0 ? 0 : 1}
      pageRangeDisplayed={pageRangeDisplayed}
      onPageChange={handlePageClick}
      containerClassName="flex items-center gap-1"
      activeLinkClassName={buttonVariants({
        size: "icon",
        variant: "primary",
        className: "font-bold",
      })}
      pageLinkClassName={buttonVariants({
        size: "icon",
        variant: "ghost",
      })}
    />
  );
};

export default DataTablePagination;
